import { useAppSelector } from '../../../../hooks/redux/redux'
import { useGetLayersQuery } from '../../../../store'
import { getMapIconId } from '../../../../utils/markers/getMarkerIcon'
import { EditableMarkerPlace } from './EditableMarkerPlace'
import { EditableMarkerEvent } from './EditableMarkerEvent'
import MarkerClusterGroup from 'react-leaflet-cluster'

export const Markers = () => {
  // TODO: redux refactor filtering logic
  const { currentPoints: points } = useAppSelector((state) => state.points)
  const { currentEvents: events } = useAppSelector((state) => state.events)
  const { selectedLayers, markersCleared } = useAppSelector(
    (state) => state.layers
  )

  const { currentTabSelected } = useAppSelector((state) => state.app)

  const { data: layers } = useGetLayersQuery()
  const mapIconId = getMapIconId(layers)
  const extendedPoints =
    points?.map((point) => ({ ...point, iconId: mapIconId[point.layerId] })) ||
    []

  const areEventsVisible = currentTabSelected === 'events' && events

  return (
    <>
      {!markersCleared &&
        currentTabSelected === 'locations' &&
        points &&
        extendedPoints
          .filter(
            (p) => !selectedLayers.length || selectedLayers.includes(p.layerId)
          )
          .map((point) => <EditableMarkerPlace key={point.id} {...point} />)}
      {areEventsVisible ? (
        <MarkerClusterGroup chunkedLoading>
          {events.map((eventObj) => (
            <EditableMarkerEvent key={eventObj.id} {...eventObj} />
          ))}
        </MarkerClusterGroup>
      ) : null}
    </>
  )
}
